import { useTranslation } from "react-i18next";
import React, {useEffect, useState} from "react";
import CameraForm from "./components/CameraForm";
import {ECameraName, VideoSettingsWrapper} from "../../interfaces";
import {Controller, SubmitHandler, useForm} from "react-hook-form";
import {settingsService} from "@shared/ui";


const CameraVideoSettings: React.FC<{ droneId: string }> = ({ droneId }) => {
  const [camerasSettings, setCamerasSettings] = useState<VideoSettingsWrapper>({ useAdaptiveBitrate:false, cameras: [] });
  const { t } = useTranslation();
  /*const camerasSettings: ICameraSettings[] = [
    {
      name: "Name",
      useAdaptiveBitrate: false,
      settings: [
        {
          resolution: EVideoResolution.FULL_HD,
          bitrate: 5,
          fps: 5,
          keyframe: 5,
        },
        {
          resolution: EVideoResolution.FULL_HD,
          bitrate: 5,
          fps: 5,
          keyframe: 5,
        }
      ],
    },
    {
      name: "Name 2",
      useAdaptiveBitrate: false,
      settings: [{
        resolution: EVideoResolution.VGA,
        bitrate: 9,
        fps: 9,
        keyframe: 9,
      },
        {
          resolution: EVideoResolution.VGA,
          bitrate: 9,
          fps: 9,
          keyframe: 9,
        }
      ],
    },
  ];
*/

  useEffect(() => {
    settingsService.getVideoSettings(droneId).then((data) => {
      console.log(data);
      setCamerasSettings(data);
    });
  },[]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm<VideoSettingsWrapper>({
    defaultValues: camerasSettings
  });

  /*const addCamera = () => {
    setCamerasSettings([...camerasSettings, {
      name: `Camera ${camerasSettings.length + 1}`,
      useAdaptiveBitrate: false,
      settings: [
        {
          resolution: EVideoResolution.FULL_HD,
          bitrate: 5,
          fps: 5,
          keyFrameFrequency: 5,
        },
        {
          resolution: EVideoResolution.FULL_HD,
          bitrate: 5,
          fps: 5,
          keyFrameFrequency: 5,
        }
      ],
    }]);
  }*/

  const onSubmit: SubmitHandler<VideoSettingsWrapper> = async (data) => {
    //const cameraSettingsData: ICameraSettings[] = data.cameras;
    data.cameras.map(c => {
      c.settings.map(s => {
        s.isMain = s.isMainStr == 1? true: false;
        return s;
      });
      return c;
    });
    await settingsService.saveVideoSettings(droneId, data);

    console.log(data);
  };

  return (
    <div className="camera-settings-form p-20">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form-wrapper settings-form">
          <div className="input-wrapper input-wrapper-checkbox">
            <Controller
              name="useAdaptiveBitrate"
              control={control}
              render={({ field }) => (
                <input
                  type="checkbox"
                  id="drone"
                  checked={field.value}
                  onChange={field.onChange}
                />
              )}
            />
            <label htmlFor="drone">{t("cameraSettings.labels.adaptiveBitrate")}</label>
          </div>
        </div>

        {camerasSettings.cameras.map((camera, camIndex) => {
          return (
            <div key={camIndex}>
              <input
                  type="hidden"
                  value={camera.cameraId}
                  {...register(`cameras.${camIndex}.cameraId`)}
              />
              <h3>{camera.name}</h3>
              <input
                  {...register(`cameras.${camIndex}.name`)}
                  type="hidden"
                  value={camera.name}
              />
              <input
                  {...register(`cameras.${camIndex}.vendor`)}
                  type="hidden"
                  value={camera.vendor}
              />
              <div className="camera-settings-wrapper">
                {camera.settings.map((s, sIndex) => {
                  return (
                      <div>
                        <h4>{camera.settings[sIndex].isMain ? "Основний потік": "Додатковий потік"}</h4>
                        <CameraForm
                            settings={camera.settings[sIndex]}
                            register={register}
                            errors={errors}
                            namePrefix={`cameras.${camIndex}.settings.${sIndex}`}
                            isMainStream={camera.settings[sIndex].isMain}
                            cameraVendor={camera.vendor}
                        />
                      </div>
                  )})}
              </div>
            </div>
          );
        })}

        <button type="submit" className="btn">
          {t("cameraSettings.submit")}
        </button>
      </form>
    </div>
  );
};

export default CameraVideoSettings;
